(function (angular) {
    'use strict';

    angular.module('shared')
        .controller('controlsCtrl', ['$scope', 'NgTableParams', "$filter", "$uibModal", function ($scope, NgTableParams, $filter, $uibModal) {

            $scope.editorOptions = {
                lineWrapping: true,
                lineNumbers: true,
                theme: "panda-syntax",
                mode: { name: "javascript", json: true }
            };

            $scope.values = {
                switch1: true,
                switch2: true
            }

            $scope.selectedType = undefined;
            $scope.types = ["string", "number", "date", "link", "image", "boolean"];


            $scope.selectedType = "string";
            $scope.selectType = function (type) {
                $scope.selectedType = type;
            };

            $scope.options = {
                users: [{ username: "marta.krzemieniewska@comapi.com" }, { username: "stevan.lepojevic@comapi.com" }, { username: "ben.moore@comapi.com" }]
            };

            $scope.selected = {
                members: [{ username: "marta.krzemieniewska@comapi.com" }]
            };
            $scope.exitValidation = function () {
                return true;
            };
            $scope.tableData = [];

            for (var i = 0; i < 200; i++) {
                $scope.tableData.push({
                    name: "Item " + i,
                    age: i
                });
            }

            $scope.tableParams = new NgTableParams(
                {
                    page: 1,
                    count: 10,
                    // initial sort order
                    sorting: { name: "desc" }
                },
                {
                    getData: function ($q, params) {
                        var orderedData = params.sorting() ?
                            $filter('orderBy')($scope.tableData, params.orderBy()) : $scope.tableData;
                        params.total($scope.tableData.length);

                        $q.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
                    }
                });


            function getDayClass(data) {
                var date = data.date,
                    mode = data.mode;
                if (mode === 'day') {
                    var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

                    for (var i = 0; i < $scope.events.length; i++) {
                        var currentDay = new Date($scope.events[i].date).setHours(0, 0, 0, 0);

                        if (dayToCheck === currentDay) {
                            return $scope.events[i].status;
                        }
                    }
                }

                return '';
            }


            $scope.showModal = function () {

                var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'shared/controls/controlsModalView.html',
                    controller: 'controlsModal',
                    size: "lg"
                });

                return modalInstance.result
                    .then(function (info) {
                    });
            }


        }]);

})(window.angular);